<script>
export default {
    name: "CardTemplate",

    props: {
        bg: {
            type: String,
            default: `bg-blue-100`
        }
    }
}
</script>
<template>
<div class="mt-2 bg-gray-200">
    <div class="border border-gray-400 shadow rounded-md">
        <div class="border-b border-gray-400 p-1 bg-gray-400">
            <slot name="card-header"></slot>
        </div>
        <div :class="bg" class="p-1">
            <slot name="card-body"></slot>
        </div>
        <div class="p-1 border-t border-gray-400 bg-gray-400">
            <slot name="card-footer"></slot>
        </div>
    </div>
</div>
</template>
